(() => {
  if (customElements.get('c4-featured-products')) return;

  class C4FeaturedProducts extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-c4-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-c4-panel]'));

      this.placeZclTags();

      if (!this.tabs.length) return;

      this.handleClick = this.onClick.bind(this);
      this.handleKeydown = this.onKeydown.bind(this);
      this.handleBlockSelect = this.onBlockSelect.bind(this);

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    placeZclTags() {
      this.querySelectorAll('[data-c4-zcl-tag]').forEach((tag) => {
        const slide = tag.closest('[data-c4-product-slide]');
        const media = slide?.querySelector('.card-product__media');

        if (!media || tag.parentElement === media) return;

        tag.hidden = false;
        media.appendChild(tag);
      });
    }

    onClick(event) {
      const tab = event.target.closest('[data-c4-tab]');
      if (!tab || !this.contains(tab)) return;

      this.activateTab(this.tabs.indexOf(tab), false);
    }

    onKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.target);
      if (currentIndex === -1) return;

      let nextIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.activateTab(nextIndex, true);
    }

    onBlockSelect(event) {
      const blockId = event.target?.dataset?.blockId;
      if (!blockId || !this.querySelector(`[data-c4-panel][data-block-id="${blockId}"]`)) return;

      const tabIndex = this.tabs.findIndex((tab) => tab.dataset.blockId === blockId);
      this.activateTab(tabIndex, false);
    }

    activateTab(index, moveFocus) {
      if (index < 0 || index >= this.tabs.length) return;

      this.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;
        panel.hidden = !isActive;
        this.toggleCarousel(panel, isActive);
      });

      if (moveFocus) this.tabs[index].focus();
    }

    toggleCarousel(panel, isActive) {
      const carousel = panel.querySelector('products-carousel');
      const slider = carousel?.slider;

      if (!slider || typeof slider.update !== 'function') return;

      if (isActive) {
        requestAnimationFrame(() => {
          slider.update();
          slider.autoplay?.start();
        });
      } else {
        slider.autoplay?.stop();
      }
    }
  }

  customElements.define('c4-featured-products', C4FeaturedProducts);
})();
